import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9fk13xj7jn: FaireBrandEntity = {
  token: "b_9fk13xj7jn",
  type: "brand",
  name: "MONAG",
  avatarUrl:
    "https://cdn.faire.com/fastly/3e52145820e8e8c1edbd6a1b56d675bfa76db12d2532ea0a40f4600080acea0c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6ef349362e6b6a3b2612044af2bc08916d299143a2bf9663205d4743fe740efa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3e52145820e8e8c1edbd6a1b56d675bfa76db12d2532ea0a40f4600080acea0c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ef349362e6b6a3b2612044af2bc08916d299143a2bf9663205d4743fe740efa.jpeg",
  location: "Farmington, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "MONAG Apparel is a manufacturer of premium quality blank apparel for children and adults. Our corporate headquarters and distribution center is located in Farmington, NY.  We provide a large selection of premium quality apparel for newborn, infant, toddler, youth, maternity, women, men and pets. We have state of the art equipment, our production lines can cater to your style, designs, color and fabric specifications to meet your requirements. We are continuously introducing new designs and styles to meet the needs of the global market. Our mission is to provide eco friendly, stylish, comfortable and premium quality clothing for the entire family.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:05.826Z",
    importedBy: "entity-db-cli",
  },
};
